export const environment = {
	production: false,
	isMockEnabled: false, // You have to switch this, when your real back-end is done
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	loginApi: 'https://dev-api.etaxi.sa.com/api/v1/',
	api: 'https://dev-api.etaxi.sa.com/portal/api/v1/',
	driverApi: 'https://dev-api.etaxi.sa.com/drivers/api/v1/',
	user_id:'idce9d77b308c149d5992a80073637e4d5',
	role_id:'roleidce9d77b308c149d5992a80073637e4d5',
	webUrl:'http://dev.etaxi.sa.com/',
	hyperpay: {
		baseUrl: 'https://eu-test.oppwa.com',
		widgetUrl: '/v1/paymentWidgets.js'
	}
};
